/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetLiveKitSipTrunksResult } from '../../models/get-live-kit-sip-trunks-result';

export interface ApiAdminLivekitSipTrunksGet$Params {
}

export function apiAdminLivekitSipTrunksGet(http: HttpClient, rootUrl: string, params?: ApiAdminLivekitSipTrunksGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLiveKitSipTrunksResult>> {
  const rb = new RequestBuilder(rootUrl, apiAdminLivekitSipTrunksGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetLiveKitSipTrunksResult>;
    })
  );
}

apiAdminLivekitSipTrunksGet.PATH = '/api/Admin/livekit/sip/trunks';
